import React from "react";
import "./styles.css";

function TramyCard({ icon, title, description }) {
  return (
    <div className="tramy-card">
      <img src={icon} alt="icon" />
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  );
}

export default TramyCard;
